import * as React from 'react';
import * as _ from 'lodash';
import AddToCartButton from '../../../generic/AddToCartButton/';
import math from '../../../../redux/modules/utils/math';
export default function () {
    function scopeHasDiscount1(selectedVariant) {
        var hasDiscount = selectedVariant.regularPrice && selectedVariant.regularPrice !== selectedVariant.price;
        return React.createElement('div', {
            'className': 'price-add-cart',
            'key': '525'
        }, React.createElement('div', { 'className': 'price' }, hasDiscount ? React.createElement('span', {
            'className': 'price-before-discount',
            'key': '729'
        }, '\n        $', math.toFixed(selectedVariant.regularPrice), '\n      ') : null, '\n      $', math.toFixed(selectedVariant.price), '\n    '), React.createElement(AddToCartButton, { 'url': selectedVariant.url }, React.createElement('span', {}, 'Add to Cart')));
    }
    function repeatOption2(selectedVariant, option, optionIndex) {
        return React.createElement('option', {
            'key': option.url,
            'value': option.url
        }, option.name);
    }
    function scopeSelectedVariant3() {
        var selectedVariant = this.getSelectedVariant();
        return React.createElement('div', { 'className': 'merch' }, React.createElement('div', { 'className': 'img-holder' }, !selectedVariant.inStock ? React.createElement('div', {
            'className': 'no-stock',
            'key': '280'
        }, 'Out of Stock') : null, React.createElement('img', {
            'src': this.props.previewPhoto.large,
            'onClick': () => {
                this.props.openImagesModal([{ src: this.props.photo.original }]);
            },
            'alt': this.props.title
        })), selectedVariant.inStock ? scopeHasDiscount1.apply(this, [selectedVariant]) : null, React.createElement('div', { 'className': 'title' }, this.props.title), React.createElement('div', { 'className': 'description' }, this.props.description), this.props.variants.length > 1 && this.props.variants[0].name ? React.createElement.apply(this, [
            'select',
            {
                'aria-label': 'Select size',
                'onChange': e => this.props.onSelectVariant(this.props.id, e.target.value),
                'key': '1123'
            },
            _.map(this.props.variants, repeatOption2.bind(this, selectedVariant))
        ]) : null);
    }
    return scopeSelectedVariant3.apply(this, []);
}